<header class="l_header product-header js-app-header">
  <div class="start">
    <!-- <div class="expand-button" (click)="navExpanded = !navExpanded">
      <ng-container *ngIf="!navExpanded">&gt;</ng-container>
      <ng-container *ngIf="navExpanded">&lt;</ng-container>
    </div> -->
    <div
      class="logo-container"
      [ngbTooltip]="i18n.Core_Home"
      container="body"
      placement="right"
    >
      <a
        [routerLink]="profileUrlName + '/dashboard/discover'"
        data-dgat="product-header-5f2"
      >
        <!-- branding tbd -->
        <!-- <img
          [src]="productImageSrcset?.orig | blobifyUrl: true"
          [srcset]="productImageSrcValue"
          alt="Degreed"
          class="logo"
          role="img"
        /> -->

        <!-- TODO: change to make this reusable, possibly -->
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="logo"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.2624 15.1156L20.2595 10.6838L19.9913 10.5263C19.7677 10.4363 19.5219 10.3913 19.276 10.3913C19.0301 10.3913 18.7842 10.4363 18.5606 10.5263L18.2477 10.7063L16.9958 11.4037C16.9735 11.4262 16.9735 11.4486 16.9958 11.4711L17.51 11.7411L20.5278 13.4059L22.3161 14.3957C22.3161 14.3957 19.6783 14.5082 17.2417 15.9255C16.7946 16.1954 16.2805 16.3304 15.7663 16.3304H15.6545C15.1404 16.3304 14.6262 16.1954 14.1792 15.9255C11.7425 14.5082 9.10472 14.3957 9.10472 14.3957L15.6993 10.7288L18.0465 9.40145C18.2924 9.26647 19.1418 8.72656 20.1031 9.01901C20.5278 9.13149 21.2431 9.53643 21.8244 9.87388C22.2938 10.1438 22.875 10.0539 23.2327 9.62642C23.4115 9.40145 23.5009 9.15399 23.5009 8.88403C23.5009 8.50159 23.3221 8.14164 22.9644 7.91668C22.2044 7.44425 21.1537 6.88183 20.3043 6.74685C18.1135 6.36441 16.7276 7.44425 15.6769 8.00666C14.8721 7.35426 13.2403 6.38691 11.0719 6.74685C10.2001 6.90433 9.17179 7.44425 8.41174 7.91668C7.83052 8.27662 7.6964 9.0865 8.14348 9.60392C8.36703 9.85139 8.67999 9.98637 8.99295 9.98637C9.19414 9.98637 9.37297 9.94137 9.55181 9.82889C10.133 9.49144 10.8484 9.0865 11.2731 8.97402C12.4132 8.65907 13.3968 9.40145 13.3968 9.40145L3.0914 15.1156C2.82315 15.2506 2.66667 15.543 2.66667 15.8355V17.2528C2.66667 17.5452 2.82315 17.8152 3.0914 17.9727C3.35965 18.1076 3.42672 18.1976 3.42672 18.7151C3.42672 19.6149 2.82315 24.5417 9.21649 24.5417C14.9616 24.5417 14.2462 18.895 15.6769 18.9175C17.1299 18.895 16.4146 24.5417 22.1373 24.5417C28.5307 24.5417 27.9271 19.6149 27.9271 18.7151C27.9271 18.1976 27.9718 18.1301 28.24 17.9727C28.5083 17.8377 28.6648 17.5452 28.6648 17.2528V15.8355C28.6871 15.5205 28.5083 15.2506 28.2624 15.1156ZM12.1896 21.0997C11.5637 22.427 10.4683 22.6295 8.88118 22.562C7.6964 22.517 6.60103 22.1345 6.04218 21.4821C5.23742 20.5598 5.32684 17.7927 5.6398 17.1853C6.24336 16.0155 11.7872 16.3754 12.5249 17.8602C12.6144 18.0177 13.1062 19.1875 12.1896 21.0997ZM25.3116 21.4821C24.7528 22.1121 23.6574 22.4945 22.4726 22.562C20.9078 22.6295 19.8125 22.427 19.1642 21.0997C18.2477 19.1875 18.7394 18.0177 18.8065 17.8602C19.5442 16.3754 25.1104 16.0155 25.6917 17.1853C26.027 17.8152 26.1164 20.5823 25.3116 21.4821Z"
          />
        </svg>
        <span class="a11y-hide">{{ i18n.Core_Home }}</span>
      </a>
    </div>
    <!-- not sure where this is going to go yet -->
    <span class="title" *ngIf="navigationInfo?.title">
      <h1>{{ navigationInfo.title }}</h1>
    </span>
  </div>

  <dgx-top-navigation-menu></dgx-top-navigation-menu>

  <div class="utility-bar">
    <dgx-product-switcher
      [hasLightText]="false"
      [refreshIcon]="true"
    ></dgx-product-switcher>
  </div>
</header>

<nav
  class="vertical-nav"
  [class.expanded]="navExpanded"
  [attr.aria-label]="i18n.A11y_MainPagesNavType"
>
  <ul class="top">
    <!-- Featured -->
    <li
      *ngIf="showFeaturedNavLink"
      routerLinkActive="active"
      [ngbTooltip]="i18n.AppHeader_FeaturedTitle"
      container="body"
      placement="right"
    >
      <a
        [routerLink]="'/explore/' + featuredPlanId"
        attr.aria-label="{{ i18n.AppHeader_FeaturedTitle }}"
        data-dgat="_AppHeader-f1c"
        class="vertical-nav-item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="nav-icon"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
          />
        </svg>
        <span class="a11y-hide">{{ i18n.AppHeader_FeaturedTitle }}</span>
      </a>
    </li>
    <!-- Opportunities -->
    <li
      routerLinkActive="active"
      *ngIf="isOpportunitiesEnabled"
      [ngbTooltip]="i18n.AppHeader_OpportunitiesTitle"
      container="body"
      placement="right"
    >
      <a
        routerLink="/career/opportunities"
        attr.aria-label="{{ i18n.AppHeader_OpportunitiesTitle }}"
        data-dgat="_AppHeader-opportunity"
        class="vertical-nav-item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="nav-icon"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
          />
        </svg>
        <span class="a11y-hide">{{ i18n.AppHeader_OpportunitiesTitle }}</span>
      </a>
    </li>
    <!-- Skill Coach -->
    <li
      routerLinkActive="active"
      *ngIf="isSkillCoachEnabled"
      [ngbTooltip]="i18n.AppHeader_SkillCoachTitle"
      container="body"
      placement="right"
    >
      <a
        routerLink="/team"
        attr.aria-label="{{ i18n.AppHeader_SkillCoachTitle }}"
        data-dgat="_AppHeader-83k"
        class="vertical-nav-item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="nav-icon"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
          />
        </svg>
        <span class="a11y-hide">{{ i18n.AppHeader_SkillCoachTitle }}</span>
      </a>
    </li>
    <!-- Academies -->
    <li
      routerLinkActive="active"
      *ngIf="isAcademiesEnabled"
      [ngbTooltip]="i18n.AppHeader_AcademiesTitle"
      container="body"
      placement="right"
    >
      <a
        routerLink="/academies"
        attr.aria-label="{{ i18n.AppHeader_AcademiesTitle }}"
        data-dgat="_AppHeader-293"
        class="vertical-nav-item"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="currentColor"
          class="nav-icon"
        >
          <path
            d="M12 21V12.75M15.75 21V12.75M8.25 21V12.75M3 9L12 3L21 9M19.5 21V10.3325C17.0563 9.94906 14.5514 9.75 12 9.75C9.44861 9.75 6.94372 9.94906 4.5 10.3325V21M3 21H21M12 6.75H12.0075V6.7575H12V6.75Z"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="a11y-hide">{{ i18n.AppHeader_AcademiesTitle }}</span>
      </a>
    </li>

    <!-- Degreed Assistant -->
    <!-- TODO: i18n titles for "Degreed Assistant"-->
    <!-- TODO: Update SVG Icon for Degreed Assistant -->
    <li
      routerLinkActive="active"
      *ngIf="isDegreedAssistantEnabled"
      [ngbTooltip]="'Degreed Assistant'"
      container="body"
      placement="right"
    >
      <a
        routerLink="/degreed-assistant"
        aria-label="Degreed Assistant"
        data-dgat="_AppHeader-294"
        class="vertical-nav-item"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="currentColor"
          class="nav-icon"
        >
          <path
            d="M12 21V12.75M15.75 21V12.75M8.25 21V12.75M3 9L12 3L21 9M19.5 21V10.3325C17.0563 9.94906 14.5514 9.75 12 9.75C9.44861 9.75 6.94372 9.94906 4.5 10.3325V21M3 21H21M12 6.75H12.0075V6.7575H12V6.75Z"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="a11y-hide">Degreed Assistant</span>
      </a>
    </li>
    <!-- Search -->
    <li
      routerLinkActive="active"
      [ngbTooltip]="i18n.Core_Search"
      container="body"
      placement="right"
    >
      <a
        routerLink="/learning/"
        data-dgat="lxp-nav-e1f"
        attr.aria-label="{{ i18n.Core_Search }}"
        class="vertical-nav-item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="nav-icon"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
          />
        </svg>
        <span class="a11y-hide">{{ i18n.Core_Search }}</span>
      </a>
    </li>
    <!-- Global Add -->
    <li
      class="no-hover"
      [ngbTooltip]="i18n.Core_AddContent"
      placement="right"
      container="body"
    >
      <dgx-global-add-menu
        placement="right"
        [placementOffsetLeftPixels]="24"
      ></dgx-global-add-menu>
    </li>

    <!-- Flex space -->
    <li class="spacer" role="none presentation"></li>

    <!-- Notifications -->
    <li
      routerLinkActive="active"
      *ngIf="isUserAuthenticated"
      [ngbTooltip]="i18n.User_Notifications"
      container="body"
      placement="right"
    >
      <a
        routerLink="/notifications"
        data-dgat="lxp-nav-c49"
        class="vertical-nav-item"
      >
        <dgx-notification-menu
          [disablePopover]="true"
          [refreshIcon]="true"
          hasNotificationsFormat="dot"
        ></dgx-notification-menu>
      </a>
    </li>
    <!-- Profile -->
    <li
      routerLinkActive="active"
      *ngIf="isUserAuthenticated"
      [ngClass]="isOnProfile ? 'active' : ''"
      [ngbTooltip]="i18n.AppHeader_ProfileTitle"
      container="body"
      placement="right"
    >
      <div class="vertical-nav-item">
        <dgx-profile-menu
          [orgId]="orgId"
          [hasLightText]="false"
          [placement]="['right', 'top-right', 'bottom-right', 'auto']"
          [isAppendToBody]="true"
        ></dgx-profile-menu>
      </div>
    </li>
  </ul>
</nav>
